<ra-modal [size]="'large'" [title]="('document.edit.listTrash.title' | translate)" (close)="close.emit()">

    @if (loading() || loadingRestoreField()) 
    {
        <div class="container-loading">
            <ra-loading
                [message]="loadingRestoreField()
                    ? ('document.edit.listTrash.restoring' | translate)
                    : ('document.edit.listTrash.loading' | translate)" 
            />
        </div>
    }
    @else if (trashDocumentItems().length === 0) 
    {
        <div class="container-empty">
            <ra-empty 
                [title]="('document.edit.listTrash.emptyTitle' | translate)"
                [message]="('document.edit.listTrash.emptyMessage' | translate)" 
            />
        </div>
    }
    @else 
    {
        <p class="ra-label-s content-secondary description-action">
            {{ 'document.edit.listTrash.hint' | translate }}
        </p>

        <div class="container-favorite-fields">
            @for (trashDocumentItem of trashDocumentItems(); track trashDocumentItem._id) 
            {
                @let item = trashDocumentItem.item;

                @if (item.type == 'TEXT' || item.type == 'SUBTITLE' || item.type == 'TITLE') 
                {
                    <text-card 
                        [type]="cardTypes.TRASH" 
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)" 
                        (click)="selectItem(trashDocumentItem)" 
                    />
                }
                @else if (item.type == 'IMAGE') 
                {
                    <image-card 
                        [type]="cardTypes.TRASH" 
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)" 
                        (click)="selectItem(trashDocumentItem)" 
                    />
                }
                @else if (item.type == 'VIDEO') 
                {
                    <video-card 
                        [type]="cardTypes.TRASH" 
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)" 
                        (click)="selectItem(trashDocumentItem)" 
                    />
                }
                @else if (item.type == 'GROUP_IMAGE') 
                {
                    <group-image-card 
                        [type]="cardTypes.TRASH" 
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)" (click)="selectItem(trashDocumentItem)" 
                    />
                }
                @else if (item.type == 'CALLOUT')
                {
                    <callout-card
                        [type]="cardTypes.TRASH"
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)"
                        (click)="selectItem(trashDocumentItem)"
                    />
                }
                @else if (item.type == 'STATS')
                {
                    <stats-card
                        [type]="cardTypes.TRASH"
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)"
                        (click)="selectItem(trashDocumentItem)"
                    />
                }
                @else if (item.type == 'TABLE')
                {
                    <table-card
                        [type]="cardTypes.TRASH"
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)"
                        (click)="selectItem(trashDocumentItem)"
                    />
                }
                @else if (item.type == 'SEMAPHORE')
                {
                    <semaphore-card
                        [type]="cardTypes.TRASH"
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)"
                        (click)="selectItem(trashDocumentItem)"
                    />
                }
                @else if (item.type == 'CHART')
                {
                    <chart-card
                        [type]="cardTypes.TRASH"
                        [trashField]="trashDocumentItem"
                        [selected]="isItemSelected(trashDocumentItem)"
                        (click)="selectItem(trashDocumentItem)"
                    />
                }
            }
        </div>
    }

    <div class="container-actions">

        <div class="container-actions-left">
            <ra-button 
                [label]="itemsSelected().length > 1
                    ? ('document.edit.listTrash.deleteMany' | translate)
                    : ('document.edit.listTrash.deleteOne' | translate)" 
                [type]="'danger'"
                [disabled]="itemsSelected().length === 0" 
                (click)="deletePermanentlyItems()"
            />
        </div>

        <div class="container-actions-right">
            <ra-button 
                [label]="'common.cancel' | translate" 
                [type]="'primary-outline'" 
                (click)="close.emit()" 
            />

            <ra-button 
                [label]="itemsSelected().length > 1
                    ? ('document.edit.listTrash.restoreMany' | translate)
                    : ('document.edit.listTrash.restoreOne' | translate)" 
                [type]="'primary'"
                [disabled]="itemsSelected().length === 0" 
                [loading]="loadingRestoreField()" 
                (click)="restoreItems()" 
            />
        </div>
    </div>
</ra-modal>
